import Icon from "@ant-design/icons";
import { jsx as _jsx } from "react/jsx-runtime";
export function KnobsOutlined(props) {
  return /*#__PURE__*/_jsx(Icon, {
    ...props,
    viewBox: "0 0 16 16",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.5 2h-1v5h1V2zm6.1 5H6.4L6 6.45v-1L6.4 5h3.2l.4.5v1l-.4.5zm-5 3H1.4L1 9.5v-1l.4-.5h3.2l.4.5v1l-.4.5zm3.9-8h-1v2h1V2zm-1 6h1v6h-1V8zm-4 3h-1v3h1v-3zm7.9 0h3.19l.4-.5v-.95l-.4-.5H11.4l-.4.5v.95l.4.5zm2.1-9h-1v6h1V2zm-1 10h1v2h-1v-2z"
    })
  });
}